import script from "./Bar.vue?vue&type=script&setup=true&lang=ts"
export * from "./Bar.vue?vue&type=script&setup=true&lang=ts"

import "./Bar.vue?vue&type=style&index=0&id=bfec4304&scoped=true&lang=css"
import "./Bar.vue?vue&type=style&index=1&id=bfec4304&lang=css"

import exportComponent from "/home/runner/work/islander-vue-web/islander-vue-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bfec4304"]])

export default __exports__